var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpInclusionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64339 5.52365C1.42688 5.52428 1.21498 5.58777 1.03218 5.70678C0.849387 5.82579 0.703173 5.99546 0.610458 6.19616C0.517743 6.39686 0.482314 6.62038 0.508271 6.84088C0.534228 7.06137 0.62051 7.26982 0.757135 7.44211L3.66965 11.1021C3.7735 11.2343 3.90661 11.3393 4.05794 11.4082C4.20926 11.4771 4.37443 11.508 4.53972 11.4982C4.89324 11.4788 5.2124 11.2848 5.41589 10.9658L11.4659 0.970612C11.4669 0.968954 11.468 0.967296 11.469 0.965663C11.5258 0.876251 11.5074 0.699061 11.3902 0.587748C11.358 0.55718 11.3201 0.533696 11.2787 0.518741C11.2373 0.503786 11.1934 0.497677 11.1497 0.50079C11.1059 0.503904 11.0632 0.516174 11.0243 0.536845C10.9853 0.557516 10.9509 0.58615 10.9231 0.620984C10.9209 0.623723 10.9187 0.62642 10.9164 0.629076L4.81486 7.70094C4.79164 7.72785 4.76344 7.74976 4.7319 7.7654C4.70036 7.78103 4.6661 7.79009 4.63112 7.79203C4.59614 7.79397 4.56113 7.78876 4.52813 7.7767C4.49513 7.76465 4.46479 7.74599 4.43888 7.7218L2.41389 5.83146C2.20358 5.63369 1.92869 5.52388 1.64339 5.52365Z",
    fill: "#3D3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpInclusionIcon);
export default __webpack_public_path__ + "static/media/rp_inclusion_icon.6298c185def07d3b4854507a618fc7e5.svg";
export { ForwardRef as ReactComponent };